import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
